<mat-nav-list>
  <ng-container *ngFor="let item of items; trackBy:trackByFn">
    <ng-container *ngIf="item.subitems">
      <mat-accordion>
        <mat-expansion-panel class="panel"
                             [expanded]="true">
          <mat-expansion-panel-header class="panel-header"
                                      collapsedHeight="48px"
                                      expandedHeight="48px">
            <mat-panel-title>
              <a class="item"
                 mat-list-item
                 [routerLink]="item.url"
                 [queryParams]="item.query"
                 [ngClass]="{ 'item--selected': item.selected }"
                 (click)="$event.stopPropagation(); emitItemSelectedEvent()">
                <div class="item-body">
                  <mat-icon class="item-body__icon">{{ item.icon }}</mat-icon>
                  <div class="item-body__label">{{ item.label }}</div>
                </div>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span *ngFor="let subitem of item.subitems; trackBy: trackByFn">
            <a class="sub-item"
               mat-list-item
               [routerLink]="subitem.url"
               [queryParams]="subitem.query"
               [ngClass]="{ 'sub-item--selected': subitem.selected }"
               (click)="$event.stopPropagation(); emitItemSelectedEvent()">
              <div class="sub-item-label">{{ subitem.label }}</div>
            </a>
          </span>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <ng-container *ngIf="!item.subitems">
      <a class="item"
         mat-list-item
         [routerLink]="item.url"
         [queryParams]="item.query"
         [ngClass]="{ 'item--selected': item.selected }"
         (click)="emitItemSelectedEvent()">
        <div class="item-body">
          <mat-icon class="item-body__icon">{{ item.icon }}</mat-icon>
          <div class="item-body__label">{{ item.label }}</div>
        </div>
      </a>
    </ng-container>
  </ng-container>
</mat-nav-list>
